export default [
  {
    path: '/main/financial/contracts',
    meta: {
      tag: 'list_financial_contracts',
      name: 'Contratos (Financeiro)',
      breadcrumb: 'Contratos (Financeiro)'
    },
    component: () => import(/* webpackChunkName: "financial-contracts-list" */ '@/views/main/settings/financial/contract/Index.vue'),
    children: [
      {
        path: '',
        name: 'listfinancialcontract',
        meta: {
          tag: 'list_financial_contracts',
          menu: 'settings',
          name: 'Contratos (Financeiro)'
        },
        component: () => import(/* webpackChunkName: "financial-contracts-list" */ '@/views/main/settings/financial/contract/List.vue'),
      },
      {
        path: '/main/financial/contract/add',
        name: 'addfinancialcontract',
        meta: {
          tag: 'add_financial_contract',
          menu: 'settings',
          name: 'Adicionar | Contrato (Financeiro)',
          breadcrumb: 'Adicionar Contrato (Financeiro)'
        },
        component: () => import(/* webpackChunkName: "financial-contract-add" */ '@/views/main/settings/financial/contract/Add.vue')
      },
      {
        path: '/main/financial/contract/:id',
        name: 'editfinancialcontract',
        meta: {
          tag: 'edit_financial_contract',
          menu: 'settings',
          name: 'Editar | Contrato (Financeiro)',
          breadcrumb: 'Editar Contrato (Financeiro)'
        },
        component: () => import(/* webpackChunkName: "financial-contract-edit" */ '@/views/main/settings/financial/contract/Edit.vue')
      }
    ]
  }
]
